import { render, staticRenderFns } from "./product_detail_popover.html?vue&type=template&id=46c3b208&scoped=true&"
import script from "./product_detail_popover.ts?vue&type=script&lang=js&"
export * from "./product_detail_popover.ts?vue&type=script&lang=js&"
import style0 from "./product_detail_popover.scss?vue&type=style&index=0&id=46c3b208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3b208",
  null
  
)

export default component.exports